import * as React from 'react';
import './rvChart.css';

interface ChartStatTile {
    label: string;
    value: React.ReactNode;
    // the colour dot ties the figure to the matching series in the chart's legend
    color?: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

interface ChartStatTilesProps {
    // a small line above the tiles that says what they count ("Current matters")
    caption?: string;
    tiles: ChartStatTile[];
}

// The secondary figures under a chart's headline number ("328.0 Billable, 1.0 Non-billable, $151,423 Total fees") as small labelled
// tiles instead of one muted line. Display only; the values and click-throughs are the chart's own.
export const ChartStatTiles: React.FC<ChartStatTilesProps> = ({ caption, tiles }) => (
    <>
        {caption && <div className="rv-stat-caption">{caption}</div>}
        <div className="rv-stat-tiles">
            {tiles.map((tile) => (
                <div
                    key={tile.label}
                    className={`rv-stat-tile${tile.onClick ? ' rv-stat-tile--clickable' : ''}`}
                    onClick={tile.onClick}
                >
                    <div className="rv-stat-label">
                        {tile.color && <span className="rv-stat-dot" style={{ backgroundColor: tile.color }} />}
                        {tile.label}
                    </div>
                    <div className="rv-stat-value">{tile.value}</div>
                </div>
            ))}
        </div>
    </>
);
